module.exports = __webpack_public_path__ + "resources/img/img_datahunt7_m.bd1e4ec4c75760a661f8206e031e33f5.png";